module.exports = "/images/clock-pink.svg?ab945522989a69b7aea7c280f138f120";